import React from 'react';

type StatusVariant =
  | 'pending'
  | 'submitted'
  | 'approved'
  | 'rejected'
  | 'active'
  | 'inactive'
  | 'admin'
  | 'engineer'
  | 'manager'
  | 'guest'
  | string;

interface StatusBadgeProps {
  status: StatusVariant;
  label?: string;
}

const STATUS_LABELS: Record<string, string> = {
  pending:    'Ожидает',
  waiting_witness: 'Ожидает подтверждения коллеги',
  submitted:  'Отправлено',
  approved:   'Одобрено',
  rejected:   'Отклонено',
  witness_rejected: 'Участие не подтверждено',
  active:     'Активен',
  inactive:   'Неактивен',
  admin:      'Администратор',
  engineering_manager: 'Рук. инженеров',
  engineer:   'Инженер',
  guest:      'Гость',
};

const STATUS_CLASS: Record<string, string> = {
  pending:    'status-pending',
  waiting_witness: 'status-pending',
  submitted:  'status-submitted',
  approved:   'status-approved',
  active:     'status-approved',
  admin:      'status-approved',
  rejected:   'status-rejected',
  witness_rejected: 'status-rejected',
  inactive:   'status-rejected',
  engineer:   'status-pending',
  engineering_manager: 'status-submitted',
  guest:      'status-pending',
};

/**
 * Единый значок статуса.
 * Заменяет разрозненные <span className="status-badge status-X"> по всему проекту.
 */
const StatusBadge: React.FC<StatusBadgeProps> = ({ status, label }) => {
  const cls = STATUS_CLASS[status] || 'status-pending';
  const text = label || STATUS_LABELS[status] || status;

  return <span className={`status-badge ${cls}`}>{text}</span>;
};

export default StatusBadge;
